import { render, staticRenderFns } from "./SubjectCard.vue?vue&type=template&id=29cbbc41&scoped=true&"
import script from "./SubjectCard.vue?vue&type=script&lang=js&"
export * from "./SubjectCard.vue?vue&type=script&lang=js&"
import style0 from "./SubjectCard.vue?vue&type=style&index=0&id=29cbbc41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cbbc41",
  null
  
)

export default component.exports